import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { moduleName } from '../../constants';
import { URI } from '../../constants/URI';
import { setCustomer } from '../slices/filtersSlice';
import { appendOrderItems, removeOrderItemById, setOrderItems } from '../slices/orderSlice';
import { appendOpenOrderItems, removeOpenOrderItemById } from '../slices/productsSlice';
import { store } from '../store';

export const addOrder = async (body) => {
    const res = await handlePostRequest(URI.order, body, {
        module: moduleName.ORDER,
    });
    return res;
};

export const updateOrder = async (body) => {
    const res = await handlePutRequest(URI.order, body, {
        module: moduleName.ORDER,
        toast: false,
    });
    if (res?.ack) {
        getOrdersById(body.id);
    }
    return res;
};

export const addOrderItem = async (body, product, isAppend = true) => {
    const res = await handlePostRequest(URI.order_item, body, {
        module: moduleName.ORDER_ITEM,
        loading: false,
    });
    if (res?.ack) {
        const order = {
            ...product,
            id: res.record_id,
            product_netsuite_id: product?.netsuite_id ?? product?.product_netsuite_id,
            product_name: product?.name,
            product_code: product?.code,
            vat: product?.taxable?.toLowerCase() === 'taxable' ? 20 : 0,
            quantity: body?.quantity ?? 1,
        };
        if (isAppend) {
            store.dispatch(appendOrderItems(order));
            store.dispatch(appendOpenOrderItems(order));
        }
    }

    return res;
};

export const getOrders = async (body) => {
    const res = await handlePostRequest(URI.orders, body, {
        module: moduleName.ORDER,
    });
    return res;
};

export const deleteOrder = async (orderId) => {
    const res = await handleDeleteRequest(
        URI.order,
        { id: orderId },
        {
            module: moduleName.ORDER,
        }
    );
    return res;
};

export const getOrdersById = async (orderId) => {
    const res = await handleGetRequest(URI.order, null, {
        module: moduleName.ORDER,
        params: {
            id: orderId,
        },
    });
    if (res?.ack) {
        store.dispatch(setOrderItems(res?.order_details || []));
        store.dispatch(setCustomer(res?.order?.customer_netsuite_id || null));
    }
    return res;
};

export const removeOrderItem = async (orderItemId, orderId) => {
    const res = await handleDeleteRequest(
        URI.order_item,
        { id: orderItemId },
        {
            module: moduleName.ORDER_ITEM,
            loading: false,
        }
    );
    if (res?.ack) {
        store.dispatch(removeOrderItemById(orderItemId));
        store.dispatch(removeOpenOrderItemById(orderItemId));
        getOrdersById(orderId);
    }
    return res;
};

export const postOrderToNetSuite = async (body) => {
    const res = await handlePostRequest(URI.post_orders, body, {
        module: moduleName.POST_ORDER,
    });
    return res;
};

export const getInvoices = async (body) => {
    const res = await handlePostRequest(URI.invoices, body, {
        module: moduleName.GET_INVOICES,
    });
    return res;
};

export const getOpenOrderByCustomer = async (customerNetsuiteId) => {
    const res = await handleGetRequest(URI.open_order, null, {
        toast: false,
        params: {
            customer_netsuite_id: customerNetsuiteId,
        },
    });
    return res;
};